export default function () {
  return [
    {
      type: 'DatePicker',
      title: '申请年度',
      [$field]: 'logYear',
      readOnly: true,
      props: {
        type: 'year'
      },
      rules: []
    },
    {
      type: 'Input',
      title: '困难人员姓名',
      [$field]: 'username',
      readOnly: true,
      rules: ['']
    },
    {
      type: 'Input',
      title: '工号',
      readOnly: true,
      [$field]: 'userCode',
      rules: ['required']
    },
    {
      type: 'RemoteSelect',
      title: '性别',
      [$field]: 'gender',
      readOnly: true,
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'DM14',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['required']
    },
    {
      type: 'Input',
      title: '身份证号码',
      readOnly: true,
      [$field]: 'idCardNum',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '出生日期',
      readOnly: true,
      [$field]: 'birthday',
      rules: ['']
    },
    {
      type: 'RemoteSelect',
      title: '民族',
      readOnly: true,
      [$field]: 'nation',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'DM15',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['']
    },
    {
      type: 'RemoteSelect',
      title: '文化程度',
      readOnly: true,
      [$field]: 'education',
      props: {
        treeType: 'tireTree',
        // url: 'api-general/module/portal/user/outGetRadioList',
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'DM16',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['']
    },
    {
      type: 'RemoteSelect',
      title: '政治面貌',
      readOnly: true,
      [$field]: 'political',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'GB4762',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['']
    },
    {
      type: 'Input',
      title: '手机号',
      readOnly: true,
      [$field]: 'phone',
      rules: ['']
    },
    {
      type: 'Input',
      title: '邮箱',
      readOnly: true,
      [$field]: 'email',
      rules: ['']
    },
    {
      type: 'Input',
      title: '家庭住址',
      readOnly: true,
      [$field]: 'familyAddr',
      rules: ['']
    },
    {
      type: 'RemoteSelect',
      title: '收入来源',
      [$field]: 'incomeOrigin',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'BJ058',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['']
    },
    {
      type: 'RemoteSelect',
      title: '健康状况',
      [$field]: 'healthCondition',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'DM33',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['']
    },
    {
      type: 'RemoteSelect',
      title: '困难类别',
      [$field]: 'poorType',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'GG53',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['required']
    },
    {
      type: 'RemoteSelect',
      title: '婚姻状况',
      [$field]: 'maritalState',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'GB22612',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['']
    },
    {
      type: 'Number',
      title: '家庭人口数',
      [$field]: 'familyPopulation',
      props: {
        min: 0
      },
      rules: ['']
    },
    {
      type: 'RemoteSelect',
      title: '困难主体',
      [$field]: 'difficultSubject',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'GG54',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['required']
    },
    {
      type: 'RemoteSelect',
      title: '困难原因',
      [$field]: 'poorReason',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'KZ67',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['required']
    },
    {
      type: 'Number',
      title: '家庭月平均收入',
      props: {
        min: 0
      },
      [$field]: 'capitaMonthlyIncome',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '入党时间',
      readOnly: true,
      [$field]: 'joinPartyDate',
      rules: ['']
    },
    {
      type: 'RemoteSelect',
      title: '是否流动党员',
      [$field]: 'isFloatPartyMember',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'KZ41',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['required']
    },
    {
      type: 'Input',
      title: '所在党支部名称',
      readOnly: true,
      [$field]: 'orgName',
      rules: ['']
    },
    {
      type: 'Input',
      title: '党内职务',
      readOnly: true,
      [$field]: 'partyDuty',
      rules: ['']
    },
    {
      type: 'Input',
      title: '所在工会名称',
      [$field]: 'ghName',
      readOnly: true,
      rules: ['']
    },
    {
      type: 'Input',
      title: '工会职务',
      [$field]: 'ghDuty',
      readOnly: true,
      rules: ['']
    },
    // {
    //   type: 'RemoteSelect',
    //   title: '家庭人均年收入',
    //   [$field]: 'avgIncome',
    //   props: {
    //     url: 'api-general/module/portal/user/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'BJ068',
    //       merge: false,
    //       bizLineCode: this.bizLineCode || 'YWX01'
    //     }
    //   },
    //   rules: ['']
    // },
    // {
    //   type: 'SelectTree',
    //   title: '建国前入党没有工作老党员',
    //   [$field]: 'isNwbrc',
    //   props: {
    //     treeType: 'tireTree',
    //     url: 'api-general/module/portal/user/outGetRadioList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'KZ66',
    //       merge: false,
    //       bizLineCode: this.bizLineCode || 'YWX01'
    //     }
    //   },
    //   rules: ['']
    // },
    // {
    //   type: 'RemoteSelect',
    //   title: '是否享受优抚对象抚恤补助',
    //   [$field]: 'isSubsidy',
    //   props: {
    //     url: 'api-general/module/portal/user/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'KZ41',
    //       merge: false,
    //       bizLineCode: this.bizLineCode || 'YWX01'
    //     }
    //   },
    //   rules: ['']
    // },
    // {
    //   type: 'RemoteSelect',
    //   title: '是否享受城镇最低生活保障费',
    //   [$field]: 'isLowerEnsure',
    //   props: {
    //     url: 'api-general/module/portal/user/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'KZ41',
    //       merge: false,
    //       bizLineCode: this.bizLineCode || 'YWX01'
    //     }
    //   },
    //   rules: ['']
    // },
    {
      type: 'textarea',
      title: '已享受补助形式、金额（近三年）',
      colSpan: 24,
      props: {
        maxlength: 500
      },
      [$field]: 'poorSupply',
      rules: ['']
    },
    {
      type: 'textarea',
      title: '困难情况描述',
      colSpan: 24,
      props: {
        maxlength: 500
      },
      [$field]: 'poorDesc',
      rules: ['']
    },
    {
      type: 'FileUpload',
      title: '附件',
      colSpan: 24,
      [$field]: 'uploadFiles',
      props: {
        multiple: true,
        isShowFileList: true,
        data: {
          groupId: this.groupId
        }
      },
      rules: ['']
    }
  ]
}